/* eslint-disable complexity, no-unused-vars, jsdoc/check-param-names, react/forbid-component-props, sonarjs/cognitive-complexity */
import classNames from 'classnames';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import ReactCookies from 'react-cookies';
import { useSelector } from 'react-redux';
import { COOKIES, GIFTING_OPTIONS } from '../../../../brands/default/constants';
import { DEAL_GIFT_BUTTON } from '../../../../brands/default/content/components/deal';
import {
  EXPRESS_GIFT_PACK,
  GIFT_PACK,
} from '../../../../brands/default/features';
import { LINK_CHECKOUT_BUTTON } from '../../../../brands/default/links';
import { trackEvent, updateDod } from '../../../../helpers/analytics';
import {
  basketCreator,
  mergeProducts,
} from '../../../../helpers/basketCreator';
import {
  getIsChooseYourProductDeal,
  getIsNationalDeal,
  isBookingCalendarOnRedemptionGiftDeal,
} from '../../../../helpers/deals';
import { scrollToProductPageDropDown } from '../../../../helpers/scroll';
import { redirectToURL } from '../../../../helpers/url';
import { getIsEligibleForVip } from '../../../../helpers/vipSubscribeHelper';
import {
  createBasket,
  fetchBasket,
  updateBasketProduct,
} from '../../../../redux/actions/basket';
import { replaceBasket } from '../../../../services/basket';
import PrimaryButton from '../../../_generic/button/PrimaryButton';

const DealGiftButton = ({
  deal = {},
  style = {},
  className = '',
  position = 0,
  buttonType = 'other',
  isSoldOut = false,
  isValidExternal,
  text = null,
  buttonRef = undefined,
  setShowEmptyMessage,
  isProductPage = false,
  rowSelection = 0,
  columnSelection = 0,
  setShowModal,
}) => {
  const router = useRouter();
  const locationStore = useSelector((state) => state.locations);
  const giftWrap = useSelector((state) => state.gifting.giftWrap);
  const standardGiftPack = useSelector((state) => state.gifting.stdGiftPack);
  const expressGiftPack = useSelector((state) => state.gifting.nddGiftPack);
  const giftPack = EXPRESS_GIFT_PACK
    ? standardGiftPack || expressGiftPack
    : standardGiftPack;
  const STANDARD_DELIVERY_ENABLED =
    ReactCookies.load(COOKIES.giftPackDeliveryTest) === 'a';
  const isBookingCalendarOnRedemptionGift =
    isBookingCalendarOnRedemptionGiftDeal(deal);
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const userVipStatus = useSelector(
    (state) => state.user.userprofile.userVipStatus,
  );
  const giftPackObject = {
    dealId: giftPack?.dealId,
    deliveryOptionType: giftPack?.deliveryOptionType,
    gift: false,
    giftPack: true,
    giftWrap: false,
    id: giftPack?.productId,
    payDeposit: false,
    quantity: 0,
  };

  // e.g. text = 'proceed' in a popup opened by gift button
  const buttonText = text ? text : DEAL_GIFT_BUTTON.giveAsAGiftButton;

  /**
   * @function - Attemps to increment the quantity of giftpacks on the basket
   * @param {string} basketToken identifier for the basket to modify
   * @param {object} products product that is being added to the basket
   * @param {object} productsAux products already existing on the basket
   */
  // const tryAddingGift = async (basketToken, products, productsAux) => {
  //   if (deal.deliveryType === 'none' && giftPack) {
  //     const giftPacks = getGiftPackQuantity(productsAux, giftPackObject.id);
  //     const totalProductQuantity = getTotalProductsQuantity(products);
  //     const quantity = giftPacks?.quantity || 0;
  //     const isIrelandSite = isIESite();
  //     if (quantity === 0) {
  //       await addBasketProduct(basketToken, {
  //         ...giftPackObject,
  //         quantity: totalProductQuantity,
  //       });
  //     } else {
  //       await updateBasketProduct(basketToken, giftPackObject.id, {
  //         giftPack: true,
  //         quantity: quantity + totalProductQuantity,
  //       });
  //     }
  //     for (const product of products) {
  //       if (isIrelandSite) {
  //         await updateBasketProduct(basketToken, product.id, {
  //           gift: true,
  //           gifting: {
  //             gift: true,
  //             giftPackProductId: giftPackObject.id,
  //             type: GIFTING_OPTIONS.STANDARD_DELIVERY_GIFT_PACK,
  //           },
  //         });
  //       } else {
  //         await updateBasketProduct(basketToken, product.id, {
  //           gift: true,
  //           gifting: {
  //             gift: true,
  //             giftPackProductId: giftPackObject.id,
  //             type: STANDARD_DELIVERY_ENABLED
  //               ? GIFTING_OPTIONS.STANDARD_DELIVERY_GIFT_PACK
  //               : GIFTING_OPTIONS.NEXT_DAY_GIFT_PACK,
  //           },
  //         });
  //       }
  //     }
  //   }
  // };

  const onClick = async () => {
    if (isValidExternal && isValidExternal() === false) return;
    trackEvent('click_buy');
    updateDod({ clickBuyType: `click_buy_gift_${buttonType}` });
    const isChooseYourProductDeal = getIsChooseYourProductDeal(deal);
    if (
      isProductPage &&
      (rowSelection === 0 || columnSelection === 0) &&
      !isChooseYourProductDeal
    ) {
      setShowEmptyMessage(true);
      scrollToProductPageDropDown();
      setShowModal(false);

      return;
    }
    if (isProductPage && rowSelection === 0 && isChooseYourProductDeal) {
      setShowEmptyMessage(true);
      scrollToProductPageDropDown();

      return;
    }
    const isNationalDeal = getIsNationalDeal(deal);
    const basketToken = ReactCookies.load(COOKIES.basketToken);
    const customerToken = ReactCookies.load(COOKIES.customerToken);
    const currentBasket = await fetchBasket(
      basketToken,
      customerToken,
      isAuthenticated,
    );

    const products = basketCreator(deal, locationStore, position, true);

    let productsAux = products;

    if (currentBasket && currentBasket.products?.length > 0) {
      // if there were products before, we merge them
      productsAux = mergeProducts(currentBasket.products, products);
    }

    // if (
    //   process.env.NEXT_PUBLIC_BRAND === SITE_WOWCHER &&
    //   deal.deliveryType !== 'none' &&
    //   !isNationalDeal
    // ) {
    //   productsAux = addWrappItem(giftWrap, productsAux, products[0]);
    // }
    const btAux =
      currentBasket && currentBasket.products && basketToken
        ? await replaceBasket(
            basketToken,
            productsAux,
            isAuthenticated,
            getIsEligibleForVip(isAuthenticated, userVipStatus),
          )
        : await createBasket(
            productsAux,
            getIsEligibleForVip(isAuthenticated, userVipStatus),
          );
    const btToken = basketToken || btAux;
    if (isNationalDeal || isBookingCalendarOnRedemptionGift || GIFT_PACK) {
      await updateBasketProduct(btToken, products[0].id, {
        gift: true,
        gifting: {
          gift: true,
          giftPackProductId: null,
          giftProductId: null,
          type: GIFTING_OPTIONS.E_GIFT,
        },
      });
    }
    // else {
    //   // we want to have a Revert the changes on 26-12-2022
    //   const currentdate = new Date();
    //   const localDayOn = dayjs('2022-12-26 00:01');
    //   const localDayOnDiff = localDayOn.diff(currentdate, 'second');

    //   if (localDayOnDiff <= 0) {
    //     await tryAddingGift(btToken, products, productsAux);
    //   }
    // }

    // if (!btAux && !basketToken) {
    //   errorTrackingService.logError({
    //     error: 'No Basket Token',
    //     message: 'Basket token cannot be undefined.',
    //   });
    // }

    if (btToken) {
      redirectToURL(`${LINK_CHECKOUT_BUTTON}/${basketToken || btAux}`, router);
    } else {
      redirectToURL(`${LINK_CHECKOUT_BUTTON}`, router);
    }
  };

  return (
    <>
      <PrimaryButton
        aria-label={DEAL_GIFT_BUTTON.giveAsAGiftButton}
        buttonRef={buttonRef}
        className={classNames(className)}
        disabled={isSoldOut}
        onClick={() => onClick()}
        style={style}
      >
        {buttonText}
      </PrimaryButton>
    </>
  );
};

DealGiftButton.propTypes = {
  buttonRef: PropTypes.object,
  buttonType: PropTypes.string,
  className: PropTypes.string,
  columnSelection: PropTypes.number,
  deal: PropTypes.object,
  isProductPage: PropTypes.bool,
  isSoldOut: PropTypes.bool,
  isValidExternal: PropTypes.func,
  position: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  rowSelection: PropTypes.number,
  setShowEmptyMessage: PropTypes.func,
  setShowModal: PropTypes.func,
  style: PropTypes.object,
  text: PropTypes.string,
};

export default DealGiftButton;
